module.exports = __webpack_public_path__ + "assets/img/logo.b543140d.jpg";